import React from "react";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import {Button} from "reactstrap";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Legal_Entities_Trustees_Object} state
 *  @property {object} model
 *  @property {Legal_Entities_Trustees_Properties} model.properties
 *  @property {Legal_Entities_Trustees_Is} model.is
 *  @property {Legal_Entities_Trustees_Has} model.has
 */
export default class LegalEntityTrustee extends ObjectOverride {
	constructor(props) {
		super(props, Types.Legal_Entities_Trustees._name, API.RequestType.READ);
	}

	render = () => {
		/** @type {Legal_Entities_Trustees_Properties} properties */
		let properties = this.model.properties;
		/** @type {Legal_Entities_Trustees_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div className="LegalEntityTrustee">
				<Framework.Elements.Select
					shouldLoad={true}
					update={this.handleSelectPropertyUpdate}
					property={properties.customer}
					object={object.customers}
					value={object.customer}
					binary_id={object.customer_binary_id}
					error={object.customer_error}
					nullable={true}
					text={'name_first&name_last'}
					sort={'name_first|name_last'}
				/>

				<div className="buttonContainer">
					<Button onClick={this.handleSubmit} color="primary" size="sm" block={true} style={{marginTop: '1px'}}>
						<i className="fa fa-plus"/>&nbsp;&nbsp;Add Trustee
					</Button>
				</div>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
